import useSend from './useSend';

function usePost<T, Req = T>(
   path: string,
): [(body: Req) => Promise<T>, T | null, Error | null] {
   return useSend<T, Req>('post', path);
}

export default usePost;
